import showSnackBar from "./SnackbarHelper";
import {WARNING} from "../constants";
import _ from 'lodash';

export function addToList(listElement, list, context, identifier) {

    if (!identifier) {
        identifier = "id";
    }
    let ifExist = function (element) {
        console.log(element[identifier]);
        console.log(listElement[identifier]);
        return element[identifier] === listElement[identifier];
    };


    let newList = [];
    if (list) {
        if (listElement === {} || (!listElement[identifier])) {
            //listElement is empty
            let newListElementToAdd = {};
            newListElementToAdd = listElement;
            let maxPosition = Math.max.apply(Math, list.map(function (clm) {
                return clm.position;
            }));

            if (maxPosition == "-Infinity") {
                maxPosition = 0;
            }

            newListElementToAdd.position = maxPosition + 1;
            list.unshift(newListElementToAdd);

            newList = list;


        } else {
            console.log(list.some(ifExist));
            if (!list.some(ifExist)) {

                let newListElementToAdd = {};
                newListElementToAdd = listElement;
                let maxPosition = Math.max.apply(Math, list.map(function (clm) {
                    return clm.position;
                }));

                if (maxPosition == "-Infinity") {
                    maxPosition = 0;
                }

                newListElementToAdd.position = maxPosition + 1;
                list.unshift(newListElementToAdd);

                newList = list;
            } else {
                showSnackBar("Can't add same item again.", WARNING, context);
                newList = list;
            }
        }

    } else {
        let newListElementToAdd = {};
        let list = [];
        newListElementToAdd = listElement;
        newListElementToAdd.position = 1;
        list[0] = listElement;

        newList = list;
    }


    return newList;
}

export function isSaved(list, identifier) {
    let savedFlag = true;
    _.map(list, (listElement) => {
        if (!listElement[identifier]) {
            savedFlag = false;
        }
    });
    return savedFlag;
}

export function handleReOrder(newOrderedIDs, list, identifier) {
    let newList = [];
    let position = list.length;
    if (newOrderedIDs && newOrderedIDs.length > 0) {
        newOrderedIDs.map(orderedId => {
            _.map(list, (listElement => {
                if (orderedId == listElement[identifier]) {
                    let newListItemToPush = {};
                    newListItemToPush = listElement;
                    newListItemToPush.position = position;
                    position = position - 1;
                    newList.push(newListItemToPush);
                }
            }));
        });
    } else {
        newList = list;
    }
    return newList
}